import { supabaseClient } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";
import { schedulesQueryOptions } from "../../schedules/api/selectSchedules";

export const observationQueryOptions = (observationId: string) => ({
	queryKey: ["observation", observationId],
	queryFn: async () => {
		const { data, error } = await supabaseClient
			.from("observations_view")
			.select("*")
			.eq("observation_id", observationId)
			.single();
		if (error) throw error;
		return data;
	},
});

export const useObservationQuery = (observationId: string) => {
	return useQuery(observationQueryOptions(observationId));
};

// Re-export the schedules query options
export { schedulesQueryOptions };
